/*! AlertLatch visual quiz */
(function () {
  "use strict";

  var LABELS = {
    basic: "Basic",
    voralarm: "Voralarm",
    mobilfunk: "Mobilfunk",
    einzelschliessend: "Einzelschließend",
    gleichschliessend: "Gleichschließend",
    "ohne-zylinder": "Ohne Zylinder",
    brandschutztuer: "Brandschutztür",
    fenster: "Fenster und Dreh-Kipp-Tür",
    panikstange: "Panikstange",
    rahmentuer: "Rahmentüre"
  };

  function initQuiz(root) {
    if (!root || root.dataset.quizReady === "true") return;
    root.dataset.quizReady = "true";

    var configEl = root.querySelector("[data-quiz-config]");
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      console.error("[Quiz] Invalid config JSON", error);
      return;
    }

    var products = normaliseProducts(config.products || []);
    var filters = normaliseFilters(config.filters || {});
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-quiz-step]"));
    var options = Array.prototype.slice.call(root.querySelectorAll("[data-answer-trigger]"));
    var progressLabel = root.querySelector("[data-progress-label]");
    var progressBar = root.querySelector("[data-progress-bar]");
    var backButton = root.querySelector("[data-quiz-back]");
    var nextButton = root.querySelector("[data-quiz-next]");
    var resetButton = root.querySelector("[data-quiz-reset]");
    var resultsGrid = root.querySelector("[data-results-grid]");
    var emptyState = root.querySelector("[data-results-empty]");
    var summary = root.querySelector("[data-results-summary]");
    var autoAdvance = root.dataset.autoAdvance !== "false";
    var selected = {};
    var currentStep = 0;
    var questionCount = Math.max(steps.length - 1, 1);

    function showStep(index) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach(function (step, stepIndex) {
        var active = stepIndex === currentStep;
        step.hidden = !active;
        step.classList.toggle("is-active", active);
      });

      updateControls();
      updateProgress();

      if (currentStep === steps.length - 1) {
        renderResults();
      }
    }

    function updateProgress() {
      var visualStep = Math.min(currentStep + 1, questionCount);
      if (progressLabel) progressLabel.textContent = visualStep + "/" + questionCount;
      if (progressBar) progressBar.style.width = (visualStep / questionCount * 100) + "%";
    }

    function updateControls() {
      if (backButton) backButton.hidden = currentStep === 0;

      if (nextButton) {
        nextButton.hidden = autoAdvance || currentStep >= questionCount;
        nextButton.disabled = !selected[currentStep];
      }
    }

    function selectOption(option) {
      var stepIndex = Number(option.dataset.questionIndex);
      var answerId = option.dataset.answerId;
      if (!answerId || Number.isNaN(stepIndex)) return;

      selected[stepIndex] = answerId;

      options.forEach(function (item) {
        if (Number(item.dataset.questionIndex) !== stepIndex) return;
        var isSelected = item === option;
        item.classList.toggle("is-selected", isSelected);
        item.setAttribute("aria-pressed", String(isSelected));
      });

      updateControls();

      if (autoAdvance) {
        window.setTimeout(function () {
          goNext();
        }, 150);
      }
    }

    function selectedAnswerIds() {
      return Object.keys(selected)
        .sort(function (a, b) { return Number(a) - Number(b); })
        .map(function (key) { return selected[key]; })
        .filter(Boolean);
    }

    function selectedFilterList() {
      return selectedAnswerIds().reduce(function (list, answerId) {
        return list.concat(filters[answerId] || []);
      }, []);
    }

    function selectedTagSummary(filterList) {
      return filterList
        .filter(function (filter) { return filter.type === "tag"; })
        .reduce(function (tags, filter) { return tags.concat(filter.args || []); }, [])
        .map(function (tag) { return LABELS[tag] || tag; })
        .filter(Boolean)
        .join(", ");
    }

    function matchingProducts() {
      var filterList = selectedFilterList();
      if (!filterList.length) return products;

      return products.filter(function (product) {
        return filterList.every(function (filter) {
          return filterMatchesProduct(filter, product);
        });
      });
    }

    function renderResults() {
      var matches = matchingProducts();
      var tags = selectedTagSummary(selectedFilterList());

      if (resultsGrid) {
        resultsGrid.innerHTML = matches.map(function (product) {
          return product.html || productCardFallback(product);
        }).join("");
      }

      if (emptyState) emptyState.hidden = matches.length > 0;
    }

    function goNext() {
      if (currentStep < questionCount && !selected[currentStep]) return;
      showStep(currentStep + 1);
    }

    function goBack() {
      showStep(currentStep - 1);
    }

    function resetQuiz() {
      selected = {};
      options.forEach(function (option) {
        option.classList.remove("is-selected");
        option.setAttribute("aria-pressed", "false");
      });
      if (resultsGrid) resultsGrid.innerHTML = "";
      if (emptyState) emptyState.hidden = true;
      showStep(0);
    }

    function addToCart(button) {
      var variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      var originalText = button.textContent;
      button.disabled = true;
      button.classList.add("is-loading");

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart add failed");
          button.textContent = "Hinzugefügt";
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        })
        .catch(function () {
          button.textContent = "Nicht hinzugefügt";
        })
        .finally(function () {
          button.classList.remove("is-loading");
          window.setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        });
    }

    options.forEach(function (option) {
      option.addEventListener("click", function () {
        selectOption(option);
      });
    });

    root.addEventListener("click", function (event) {
      var quickAdd = event.target.closest("[data-quick-add]");
      if (quickAdd && root.contains(quickAdd)) {
        addToCart(quickAdd);
      }
    });

    if (backButton) backButton.addEventListener("click", goBack);
    if (nextButton) nextButton.addEventListener("click", goNext);
    if (resetButton) resetButton.addEventListener("click", resetQuiz);

    document.addEventListener("shopify:block:select", function (event) {
      if (!config.blocks || config.blocks[event.detail.blockId] == null) return;
      showStep(config.blocks[event.detail.blockId]);
    });

    showStep(0);
  }

  function filterMatchesProduct(filter, product) {
    if (!filter || !filter.type) return true;

    if (filter.type === "tag") return hasAny(filter.args, product.tags);
    if (filter.type === "type") return hasAny(filter.args, [product.type]);
    if (filter.type === "vendor") return hasAny(filter.args, [product.vendor]);
    if (filter.type === "price") return comparePrice(filter.args, product.price);
    if (filter.type === "option") return optionMatches(filter.args, product.options);

    return true;
  }

  function optionMatches(args, options) {
    var optionName = normalise(args && args[0]);
    var wantedValues = normaliseArray(args && args[1]);
    if (!optionName || !wantedValues.length || !Array.isArray(options)) return false;

    return options.some(function (option) {
      if (normalise(option.name) !== optionName) return false;
      return hasAny(wantedValues, option.values || []);
    });
  }

  function comparePrice(args, price) {
    var value = Number(args && args[0]);
    var operator = args && args[1];
    var productPrice = Number(price);

    if (Number.isNaN(value) || Number.isNaN(productPrice)) return true;
    if (operator === ">") return productPrice > value;
    if (operator === ">=") return productPrice >= value;
    if (operator === "<") return productPrice < value;
    if (operator === "<=") return productPrice <= value;
    if (operator === "=") return productPrice === value;
    return true;
  }

  function normaliseProducts(products) {
    return products.map(function (product) {
      product.tags = normaliseArray(product.tags);
      product.type = normalise(product.type);
      product.vendor = normalise(product.vendor);
      return product;
    });
  }

  function normaliseFilters(filters) {
    return Object.keys(filters).reduce(function (acc, answerId) {
      acc[answerId] = (filters[answerId] || []).map(function (filter) {
        if (filter.type === "tag" || filter.type === "type" || filter.type === "vendor") {
          filter.args = normaliseArray(filter.args);
        }

        if (filter.type === "option" && Array.isArray(filter.args)) {
          filter.args = [normalise(filter.args[0]), normaliseArray(filter.args[1])];
        }

        return filter;
      }).filter(function (filter) {
        return filter && filter.type;
      });

      return acc;
    }, {});
  }

  function hasAny(needles, haystack) {
    var normalisedHaystack = normaliseArray(haystack);
    return normaliseArray(needles).some(function (needle) {
      return normalisedHaystack.indexOf(needle) !== -1;
    });
  }

  function normaliseArray(value) {
    if (!Array.isArray(value)) value = value == null ? [] : [value];
    return value.map(normalise).filter(Boolean);
  }

  function normalise(value) {
    return String(value || "").trim().toLowerCase();
  }

  function productCardFallback(product) {
    return [
      '<article class="quiz-product">',
      '<div class="quiz-product__content">',
      '<h3 class="quiz-product__title"><a href="' + escapeHtml(product.url || "#") + '">' + escapeHtml(product.title || "") + '</a></h3>',
      '<a class="quiz-product__link" href="' + escapeHtml(product.url || "#") + '">Zum Produkt</a>',
      '</div>',
      '</article>'
    ].join("");
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll("[data-modern-quiz]")).forEach(initQuiz);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
